import React from "react";
import { useState, useEffect } from "react";

function PTLHeader() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToForm = (e) => {
    e.preventDefault();
    const form = document.getElementById("d2c-hero-form") || document.getElementById("leadForm");
    if (form) {
      const offset = form.getBoundingClientRect().top + window.scrollY - 80;
      window.scrollTo({ top: offset, behavior: "smooth" });
      setTimeout(() => {
        const firstInput = form.querySelector("input");
        if (firstInput) firstInput.focus();
      }, 500);
    }
  };

  return (
    <>
      <div style={{
        background: "#0f172a",
        color: "#fff",
        textAlign: "center",
        padding: "10px 16px",
        fontSize: "14px",
        fontWeight: 600,
        fontFamily: "'Poppins', sans-serif",
      }}>
        <span style={{ color: "#facc15" }}>Limited Time Offer:</span>{" "}
        Free Onboarding + Earn Cashback on Your First Recharge
      </div>

      <header className={`pz-nav${scrolled ? " pz-nav--scrolled" : ""}`}>
      <div className="pz-nav__inner">
        <div className="pz-nav__logo">
          <img
            src="/media/logo.svg"
            height={52}
            alt="Prozo - Supply Chain Operating System"
          />
        </div>

        <a style={{color: "#fff"}} href="#d2c-hero-form" className="pz-nav__cta" onClick={scrollToForm}>
          Get a Free Quote <i className="mdi mdi-arrow-right" />
        </a>
      </div>
    </header>
    </>
  );
}

export default PTLHeader;
